import { AxiosResponse } from 'axios';
import ApiResponseResult, { EnrouteApiResponse } from '../models/api';
import { ServerError } from './server-error-utils';


export const mapResponse = <B = any, R extends EnrouteApiResponse = EnrouteApiResponse<B>>(
  { body, response, result, error }: R,
): B => {
  if (!result) {
    throw new Error(ServerError.InvalidResponseData);
  }
  if (result === ApiResponseResult.Failure) {
    throw new Error(error);
  }

  return body || response;
};

export const mapAxiosResponse = <
  B = any,
  R extends EnrouteApiResponse = EnrouteApiResponse<B>
  > (response: AxiosResponse<R>): B => mapResponse<B, R>(response.data)
